import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../SharedHosting.css';

const SharedHostingHe = () => {
    const scrollToPricing = (e) => {
        e.preventDefault();
        const pricingSection = document.getElementById('pricing');
        if (pricingSection) {
            const headerOffset = 100;
            const elementPosition = pricingSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>אחסון אתרים שיתופי - תוכניות מהירות, מאובטחות ומשתלמות | Epicfinal</title>
                <meta name="title" content="אחסון אתרים שיתופי - תוכניות מהירות, מאובטחות ומשתלמות | Epicfinal" />
                <meta name="description" content="אחסון שיתופי מקצועי החל מ-₪19.90 לחודש. אחסון SSD NVMe, תעודת SSL חינם, Cloudflare CDN, התקנת וורדפרס בלחיצה אחת, הגנת WAF ותמיכה 24/7. מושלם לאתרים, בלוגים ועסקים קטנים." />
                <meta name="keywords" content="אחסון שיתופי, אחסון אתרים, אחסון זול, אחסון משתלם, אחסון אתר, אחסון בלוג, אחסון לעסק קטן, אחסון NVMe, אחסון SSD, אחסון Cloudflare, אחסון SSL, אחסון וורדפרס, אחסון cPanel, אחסון ענן" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/shared-hosting" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/shared-hosting" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/shared-hosting" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/shared-hosting" />
                <meta property="og:title" content="אחסון אתרים שיתופי - מהיר, מאובטח ומשתלם | Epicfinal" />
                <meta property="og:description" content="אחסון שיתופי מקצועי החל מ-₪19.90 לחודש. אחסון SSD NVMe, תעודת SSL חינם, Cloudflare CDN ותמיכה 24/7. העלו את האתר שלכם לאוויר היום!" />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal אחסון שיתופי - אחסון אתרים מהיר ומשתלם" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/shared-hosting" />
                <meta name="twitter:title" content="אחסון אתרים שיתופי - מהיר, מאובטח ומשתלם | Epicfinal" />
                <meta name="twitter:description" content="אחסון שיתופי מקצועי החל מ-₪19.90 לחודש. SSD NVMe, SSL חינם, Cloudflare CDN ותמיכה 24/7." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "name": "אחסון אתרים שיתופי - תוכניות מהירות, מאובטחות ומשתלמות",
                        "description": "אחסון שיתופי מקצועי החל מ-$5.99 לחודש עם אחסון SSD NVMe, SSL חינם, אינטגרציה של Cloudflare CDN ותמיכה טכנית מומחית 24/7.",
                        "url": "https://epicfinal.com/he/shared-hosting",
                        "provider": {
                            "@type": "Organization",
                            "name": "Epicfinal",
                            "url": "https://epicfinal.com"
                        },
                        "breadcrumb": {
                            "@type": "BreadcrumbList",
                            "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "בית",
                                    "item": "https://epicfinal.com/he"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "אחסון שיתופי",
                                    "item": "https://epicfinal.com/he/shared-hosting"
                                }
                            ]
                        }
                    }
                `}</script>
            </Helmet>

            <div className="shared-hosting-page">
                {/* Hero Section */}
                <section className="shared-hero">
                    <div className="container">
                        <div className="shared-hero-content">
                            <h1 className="shared-hero-title shared-hero-title-he">
                                אחסון שיתופי
                            </h1>
                            <p className="shared-hero-subtitle">
                                אחסון משתלם ואמין לאתר האינטרנט שלך
                            </p>
                            <p className="shared-hero-description">
                                מושלם לאתרים אישיים, בלוגים ועסקים קטנים. העלו את האתר שלכם לאוויר במהירות עם תוכניות האחסון השיתופי הקלות לשימוש שלנו.
                            </p>
                            <div className="shared-hero-buttons">
                                <a href="#pricing" onClick={scrollToPricing} className="btn-shared btn-primary">
                                    צפו בתוכניות ומחירים
                                </a>
                                <Link to="/contact1" className="btn-shared btn-secondary">
                                    דברו עם מומחה
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="shared-features">
                    <div className="container">
                        <div className="shared-section-header">
                            <h2>למה לבחור באחסון שיתופי?</h2>
                            <p>כל מה שאתם צריכים כדי להשיק את האתר שלכם</p>
                        </div>
                        <div className="shared-features-grid">
                            <div className="shared-feature-card">
                                <div className="shared-feature-icon">
                                    <i className="las la-dollar-sign"></i>
                                </div>
                                <h3>משתלם כלכלית</h3>
                                <p>התחילו מ-₪19.90 לחודש בלבד. מושלם למשתמשים המודעים לתקציב.</p>
                            </div>
                            <div className="shared-feature-card">
                                <div className="shared-feature-icon">
                                    <i className="las la-rocket"></i>
                                </div>
                                <h3>הגדרה קלה</h3>
                                <p>העלו את האתר שלכם לאוויר תוך דקות עם המתקין שלנו בלחיצה אחת.</p>
                            </div>
                            <div className="shared-feature-card">
                                <div className="shared-feature-icon">
                                    <i className="las la-shield-alt"></i>
                                </div>
                                <h3>תעודת SSL חינם</h3>
                                <p>אבטחו את האתר שלכם עם הצפנת SSL חינמית הכלולה בכל התוכניות.</p>
                            </div>
                            <div className="shared-feature-card">
                                <div className="shared-feature-icon">
                                    <i className="las la-tachometer-alt"></i>
                                </div>
                                <h3>ביצועים גבוהים</h3>
                                <p>אחסון SSD ושרתים מותאמים מבטיחים זמני טעינה מהירים.</p>
                            </div>
                            <div className="shared-feature-card">
                                <div className="shared-feature-icon">
                                    <i className="las la-headset"></i>
                                </div>
                                <h3>תמיכה 24/7</h3>
                                <p>צוות התמיכה המומחה שלנו זמין בכל עת שתזדקקו לעזרה.</p>
                            </div>
                            <div className="shared-feature-card">
                                <div className="shared-feature-icon">
                                    <i className="las la-sync"></i>
                                </div>
                                <h3>גיבויים יומיים</h3>
                                <p>גיבויים יומיים אוטומטיים שומרים על הנתונים שלכם בטוחים ומאובטחים.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Plans Section */}
                <section className="shared-pricing" id="pricing">
                    <div className="container">
                        <div className="shared-section-header">
                            <h2>בחרו את התוכנית שלכם</h2>
                            <p>תוכניות גמישות לכל צורך</p>
                        </div>
                        <div className="shared-pricing-grid">
                            {/* Starter Plan */}
                            <div className="shared-pricing-card">
                                <div className="shared-pricing-header">
                                    <h3>epicfinal Starter</h3>
                                    <p className="shared-pricing-tagline">מיועד לעסקים קטנים, פרילנסרים ופרויקטים אישיים</p>
                                </div>
                                <div className="shared-pricing-price">
                                    <span className="shared-price-amount">₪19.90</span>
                                    <span className="shared-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="shared-pricing-features">
                                    <li><i className="las la-check"></i> <strong>אתר אחד</strong></li>
                                    <li><i className="las la-check"></i> 5GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (שימוש הוגן)</li>
                                    <li><i className="las la-check"></i> אימייל ומסדי נתונים</li>
                                    <li><i className="las la-check"></i> עד 3 מסדי נתונים</li>
                                    <li><i className="las la-check"></i> WAF – חומת אש לאפליקציות ווב</li>
                                    <li><i className="las la-check"></i> הגנה מפני תוכנות זדוניות</li>
                                    <li><i className="las la-check"></i> תעודות SSL חינם</li>
                                    <li><i className="las la-check"></i> אינטגרציית Cloudflare</li>
                                    <li><i className="las la-check"></i> פאנל ניהול ידידותי למשתמש</li>
                                    <li><i className="las la-check"></i> התקנת וורדפרס בלחיצה אחת</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/cloud-web-hosting/s1-web-starter&language=hebrew&currency=2"
                                    className="shared-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>

                            {/* Pro Plan */}
                            <div className="shared-pricing-card featured">
                                <div className="shared-pricing-badge">הפופולרי ביותר</div>
                                <div className="shared-pricing-header">
                                    <h3>epicfinal Cloud – Web Pro</h3>
                                    <p className="shared-pricing-tagline">אחסון מתקדם לאתרים צומחים</p>
                                </div>
                                <div className="shared-pricing-price">
                                    <span className="shared-price-amount">₪31.40</span>
                                    <span className="shared-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="shared-pricing-features">
                                    <li><i className="las la-check"></i> <strong>עד 3 אתרים נפרדים</strong></li>
                                    <li><i className="las la-check"></i> 15GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (שימוש הוגן)</li>
                                    <li><i className="las la-check"></i> WAF והגנה מפני תוכנות זדוניות</li>
                                    <li><i className="las la-check"></i> הגנת אנטי-ספאם לאימייל</li>
                                    <li><i className="las la-check"></i> SSL חינם לכל הדומיינים</li>
                                    <li><i className="las la-check"></i> אינטגרציית Cloudflare</li>
                                    <li><i className="las la-check"></i> התקנת וורדפרס בלחיצה אחת</li>
                                    <li><i className="las la-check"></i> עדכוני וורדפרס אוטומטיים</li>
                                    <li><i className="las la-check"></i> מטמון (Caching) לטעינת דפים מהירה יותר</li>
                                    <li><i className="las la-check"></i> גישה ללוגים וסטטיסטיקות</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/cloud-web-hosting/epicfinal-cloud-web-pro&language=hebrew&currency=2"
                                    className="shared-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>

                            {/* Business Plan */}
                            <div className="shared-pricing-card">
                                <div className="shared-pricing-header">
                                    <h3>epicfinal Business</h3>
                                    <p className="shared-pricing-tagline">ארחו מספר פרויקטים של לקוחות תחת פלטפורמה עוצמתית אחת</p>
                                </div>
                                <div className="shared-pricing-price">
                                    <span className="shared-price-amount">₪55.90</span>
                                    <span className="shared-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="shared-pricing-features">
                                    <li><i className="las la-check"></i> <strong>עד 10 אתרים</strong></li>
                                    <li><i className="las la-check"></i> 40GB NVMe SSD אחסון</li>
                                    <li><i className="las la-check"></i> תעבורה ללא הגבלה (~150 אלף ביקורים בחודש)</li>
                                    <li><i className="las la-check"></i> אידיאלי לחנויות WooCommerce</li>
                                    <li><i className="las la-check"></i> תמיכה ב-WordPress Multisite</li>
                                    <li><i className="las la-check"></i> מושלם לסוכנויות</li>
                                    <li><i className="las la-check"></i> תמיכה בפרויקטים גדולים</li>
                                    <li><i className="las la-check"></i> תמיכה בעדיפות</li>
                                    <li><i className="las la-check"></i> כל פיצ'רי ה-Pro כלולים</li>
                                    <li><i className="las la-check"></i> תכונות אבטחה מתקדמות</li>
                                    <li><i className="las la-check"></i> שותף אמין לסוכנויות</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/cloud-web-hosting/epicfinal-business&language=hebrew&currency=2"
                                    className="shared-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    מתחילים עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Perfect For Section */}
                <section className="shared-perfect">
                    <div className="container">
                        <div className="shared-section-header">
                            <h2>מתאים במיוחד עבור</h2>
                            <p>מי צריך לבחור באחסון שיתופי?</p>
                        </div>
                        <div className="shared-perfect-grid">
                            <div className="shared-perfect-card">
                                <div className="shared-perfect-icon">
                                    <i className="las la-blog"></i>
                                </div>
                                <h3>בלוגים אישיים</h3>
                                <p>התחילו את הבלוג שלכם עם פתרון אחסון משתלם ואמין.</p>
                            </div>
                            <div className="shared-perfect-card">
                                <div className="shared-perfect-icon">
                                    <i className="las la-store"></i>
                                </div>
                                <h3>עסקים קטנים</h3>
                                <p>העלו את העסק שלכם לרשת עם אתר אינטרנט מקצועי.</p>
                            </div>
                            <div className="shared-perfect-card">
                                <div className="shared-perfect-icon">
                                    <i className="las la-briefcase"></i>
                                </div>
                                <h3>אתרי פורטפוליו</h3>
                                <p>הציגו את העבודה שלכם עם פורטפוליו מהיר ויפה.</p>
                            </div>
                            <div className="shared-perfect-card">
                                <div className="shared-perfect-icon">
                                    <i className="las la-graduation-cap"></i>
                                </div>
                                <h3>אתרי חינוך</h3>
                                <p>צרו תוכן חינוכי וקורסים מקוונים.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="shared-cta">
                    <div className="container">
                        <div className="shared-cta-content">
                            <h2>מוכנים להתחיל?</h2>
                            <p>העלו את האתר שלכם לאוויר היום עם האחסון השיתופי האמין שלנו</p>
                            <div className="shared-cta-buttons">
                                <Link to="/pricing-he" className="btn-shared btn-light">
                                    בחרו את התוכנית שלכם
                                </Link>
                                <Link to="/contact1" className="btn-shared btn-outline">
                                    צרו קשר עם המכירות
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default SharedHostingHe;
